import Avatar from '@mui/material/Avatar';

import { IconCalendarEvent } from '@/components/icon/tabler/IconCalendarEvent';
import { radiusTokens } from '@/theme/themePrimitives';

interface Props {
  bannerUrl: string | null;
  name: string;
}

/** 16:9 banner thumbnail; an event without a banner shows the calendar icon. */
const EventBannerThumb = ({ bannerUrl, name }: Props) => (
  <Avatar src={bannerUrl ?? undefined} alt={name} variant="rounded" sx={sx.thumb}>
    <IconCalendarEvent sx={{ fontSize: 20 }} />
  </Avatar>
);

export default EventBannerThumb;

const sx = {
  thumb: {
    width: 64,
    height: 36,
    borderRadius: radiusTokens.lg,
    bgcolor: 'action.hover',
    color: 'text.secondary',
    flexShrink: 0,
  },
};
